// Tailwind's own default (unconfigured) scale — kept as one source here so a
// JS breakpoint decision can never disagree with the `sm:`/`md:` utilities.
export const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 } as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

export const BREAKPOINT_NAMES = Object.keys(BREAKPOINTS) as Breakpoint[];
